export const cctFieldsDic = [
  {value: 'clavecct', label: "Clave CCT"},
  {value: 'nombre', label: "Nombre del CCT"},
  {value: 'inmueble', label: "Clave de inmueble"},
  {value: 'municipio.n_municipi', label: "Municipio"},
  {value: 'serreg.n_serreg', label: "Región"},
  {value: 'domicilio', label: "Domicilio"},
]